import { createSelector } from '@reduxjs/toolkit'
import { useT } from '@transifex/react'
import { RootState } from '../../../../state/store'
import { useAppSelector } from '../../../../state/hooks'
import { hasServiceOrder } from '../../../../functions/service'
import { isLegacyServiceSale } from '../../../../functions/sale'
import { useSalePaymentLabel } from './use-sale-payment-label'

const selectData = () =>
  createSelector(
    [
      (state: RootState) => state.currentSale.status,
      (state: RootState) => state.currentSale.serviceFields,
      (state: RootState) => state.currentSale.customFields,
    ],
    (status, serviceFields, customFields) => ({
      status,
      serviceFields,
      customFields,
    })
  )

export const useShouldShowSaleServicesModal = () => {
  const t = useT()
  const { status, serviceFields, customFields } = useAppSelector(selectData())
  const saleLabel = useSalePaymentLabel()
  const refundLabel = t('Refund', { _context: 'Label for pay button' })

  return (
    saleLabel === refundLabel &&
    (hasServiceOrder(serviceFields, customFields) ||
      isLegacyServiceSale(status))
  )
}
